import React from 'react'
import ERROR from "../../Assets/images/ERROR.png";
import { Link } from 'react-router-dom';

const NoSearchFound = (formData) => {
    return (
        <>

            {/* <div className="aon-page-benner-area">
                <div
                    className="aon-page-banner-row"
                    style={{ backgroundImage: "url(../../Assets/images/job-banner.jpg)" }}
                >
                    <div
                        className="sf-overlay-main"
                        style={{ opacity: "0.8", backgroundColor: "#022279" }}
                    />
                    <div className="sf-banner-heading-wrap">
                        <div className="sf-banner-heading-area">
                            <div className="sf-banner-heading-large">Error 404</div>
                            <div className="sf-banner-breadcrumbs-nav">
                                <ul className="list-inline">
                                    <li>
                                        <a href="index.html"> Home </a>
                                    </li>
                                    <li>Error 404</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="section-full page-notfound-outer p-b90">
                <div className="container">
                    <div className="section-content">
                        <div className="page-notfound">
                            <div className="page-notfound-media">
                                <img src={ERROR} alt="" />
                            </div>
                            <div className="page-notfound-content m-b30">
                                <h3 className="error-comment">
                                    The Search You Are Looking For Doesn't Exist...
                                </h3>
                                <p>
                                    You can search on other words.
                                </p>
                                <Link to={'/'} className="site-button">
                                    Back to Home
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NoSearchFound
